/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccessTokenOptsHeader } from './AccessTokenOptsHeader';
import {
    AccessTokenOptsHeaderFromJSON,
    AccessTokenOptsHeaderFromJSONTyped,
    AccessTokenOptsHeaderToJSON,
} from './AccessTokenOptsHeader';

/**
 * Configuration that defines how an OAuth 2.0 access token is attached to
 * outbound API requests. When provided, this configuration overrides the
 * default access-token handling behavior for the connector.
 * @export
 * @interface AccessTokenOpts
 */
export interface AccessTokenOpts {
    /**
     * How the access token should be attached to requests.
     * @type {string}
     * @memberof AccessTokenOpts
     */
    attachmentType: AccessTokenOptsAttachmentTypeEnum;
    /**
     * 
     * @type {AccessTokenOptsHeader}
     * @memberof AccessTokenOpts
     */
    header?: AccessTokenOptsHeader;
    /**
     * URL with more information about how access token is used.
     * @type {string}
     * @memberof AccessTokenOpts
     */
    docsURL?: string;
}


/**
 * @export
 */
export const AccessTokenOptsAttachmentTypeEnum = {
    AccessTokenHeaderAttachment: 'accessTokenHeaderAttachment'
} as const;
export type AccessTokenOptsAttachmentTypeEnum = typeof AccessTokenOptsAttachmentTypeEnum[keyof typeof AccessTokenOptsAttachmentTypeEnum];


/**
 * Check if a given object implements the AccessTokenOpts interface.
 */
export function instanceOfAccessTokenOpts(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "attachmentType" in value;

    return isInstance;
}

export function AccessTokenOptsFromJSON(json: any): AccessTokenOpts {
    return AccessTokenOptsFromJSONTyped(json, false);
}

export function AccessTokenOptsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessTokenOpts {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attachmentType': json['attachmentType'],
        'header': !exists(json, 'header') ? undefined : AccessTokenOptsHeaderFromJSON(json['header']),
        'docsURL': !exists(json, 'docsURL') ? undefined : json['docsURL'],
    };
}

export function AccessTokenOptsToJSON(value?: AccessTokenOpts | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attachmentType': value.attachmentType,
        'header': AccessTokenOptsHeaderToJSON(value.header),
        'docsURL': value.docsURL,
    };
}

